import { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import './index.css'

import LoadingSpinner from '@/components/TailwindUI/LoadingSpinner'
import cn from '@/utilities/cn'

import mesages from './messages'

type LoaderProps = {
  isLoading?: boolean
  loadingMessage?: ReactNode
  centered?: boolean
  className?: string
}

const Loader = ({
  isLoading = true,
  loadingMessage = <FormattedMessage {...mesages.loading} />,
  centered = true,
  className
}: LoaderProps) => {
  if (!isLoading) {
    return null
  }

  return (
    <div
      className={cn(
        'fade-in flex w-full flex-col items-center group-[.is-modal]:!h-auto',
        {
          'justify-center': centered,
          'h-[90vh]': !className
        },
        className
      )}
    >
      <LoadingSpinner className="h-36 w-36" />
      <h2 className="mt-4 text-lg font-medium text-zinc-400">{loadingMessage}</h2>
    </div>
  )
}

export default Loader
